var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wheel-home" }, [
    _c("div", { staticClass: "wheel-home__container" }, [
      !_vm.isLg
        ? _c(
            "div",
            { staticClass: "wheel-sidebar" },
            [
              _c(
                "ui-game-sidebar",
                {
                  attrs: {
                    "mode-name": "Wheel",
                    icon: "icon_wheel",
                    "game-mode": "wheel",
                    userBalanceUsd: _vm.allBalance,
                    "auth-state": _vm.authState,
                    "bet-amount-usd": _vm.authState.betAmountUsd,
                    "how-it-works-slides": _vm.howItWorksSlides,
                    "round-id": _vm.wheelState.game
                      ? _vm.wheelState.game.id
                      : null,
                    fastAmounts: _vm.fastAmounts,
                    "round-hash":
                      _vm.wheelState.game && _vm.wheelState.game.fairGame
                        ? _vm.wheelState.game.fairGame.serverSeedHash
                        : null,
                    "autobets-enabled": false,
                    "min-bet-enabled": true,
                  },
                  on: {
                    "update:betAmountUsd": function ($event) {
                      return _vm.$set(_vm.authState, "betAmountUsd", $event)
                    },
                    "update:bet-amount-usd": function ($event) {
                      return _vm.$set(_vm.authState, "betAmountUsd", $event)
                    },
                    "open-how-it-works": _vm.openHowGameWorksDialog,
                  },
                },
                [
                  _c("wheel-home-bet-content", {
                    attrs: { slot: "betContent" },
                    slot: "betContent",
                    model: {
                      value: _vm.currentColor,
                      callback: function ($$v) {
                        _vm.currentColor = $$v
                      },
                      expression: "currentColor",
                    },
                  }),
                  _c("wheel-home-bet-creator", {
                    attrs: {
                      slot: "createBetButton",
                      game: _vm.wheelState.game,
                      "user-bets": _vm.wheelState.userBets,
                      userBalanceUsd: _vm.allBalance,
                      "bet-color": _vm.currentColor,
                      "is-authenticated": _vm.authState.isAuthenticated(),
                      "bet-type": _vm.authState.betType(),
                      "bet-amount-usd": _vm.authState.betAmountUsd,
                      "selected-inv-items": _vm.inventoryState.selectedIds(),
                      "selected-inventory-amount-usd":
                        _vm.inventoryState.selectedInventoryAmountUsd(),
                      "selected-ids": _vm.inventoryState.selectedIds(),
                    },
                    on: {
                      "update:betAmountUsd": function ($event) {
                        return _vm.$set(_vm.authState, "betAmountUsd", $event)
                      },
                      "update:bet-amount-usd": function ($event) {
                        return _vm.$set(_vm.authState, "betAmountUsd", $event)
                      },
                      "open-login": function ($event) {
                        return _vm.$emit("open-login-dialog")
                      },
                      "notify-error": _vm.handleNotifyError,
                      "submit-bet": _vm.handleBetSubmit,
                    },
                    slot: "createBetButton",
                  }),
                  _vm.wheelState.userBets && _vm.wheelState.userBets.length > 0
                    ? _c("wheel-sidebar-bets", {
                        attrs: {
                          slot: "userBets",
                          game: _vm.wheelState.game,
                          bets: _vm.wheelState.userBets,
                          "is-sticky-bet": false,
                        },
                        slot: "userBets",
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "wheel-game",
          class: {
            "is-running":
              _vm.wheelState.game &&
              _vm.wheelState.game.status === _vm.GameStatus.STARTED,
            "is-completed":
              _vm.wheelState.game &&
              _vm.wheelState.game.status === _vm.GameStatus.ENDED,
          },
        },
        [
          _vm.isLg
            ? _c("div", { staticClass: "wheel-game__head" }, [
                _vm._m(0),
                _c("div", { staticClass: "wheel-game__head-actions" }, [
                  _vm.howItWorksSlides
                    ? _c("span", {
                        staticClass:
                          "wheel-game__info icon icon_info-instruction",
                        on: { click: _vm.openHowGameWorksDialog },
                      })
                    : _vm._e(),
                ]),
              ])
            : _vm._e(),
          _c(
            "div",
            { staticClass: "wheel-game__header" },
            [
              _c("wheel-home-game", { attrs: { wheelState: _vm.wheelState } }),
              _c("wheel-home-history", {
                attrs: {
                  "color-stats": _vm.wheelState.colorStats,
                  history: _vm.wheelState.history,
                },
              }),
            ],
            1
          ),
          _vm.isLg
            ? _c(
                "div",
                { staticClass: "wheel-game__sidebar-new" },
                [
                  _c(
                    "ui-game-sidebar",
                    {
                      attrs: {
                        "mode-name": "Wheel",
                        icon: "icon_wheel",
                        "game-mode": "wheel",
                        userBalanceUsd: _vm.allBalance,
                        "auth-state": _vm.authState,
                        "bet-amount-usd": _vm.authState.betAmountUsd,
                        fastAmounts: _vm.fastAmounts,
                        "how-it-works-slides": _vm.howItWorksSlides,
                        "round-id": _vm.wheelState.game
                          ? _vm.wheelState.game.id
                          : null,
                        "round-hash":
                          _vm.wheelState.game && _vm.wheelState.game.fairGame
                            ? _vm.wheelState.game.fairGame.serverSeedHash
                            : null,
                        hasFairGame: false,
                        "autobets-enabled": false,
                        "min-bet-enabled": true,
                      },
                      on: {
                        "update:betAmountUsd": function ($event) {
                          return _vm.$set(_vm.authState, "betAmountUsd", $event)
                        },
                        "update:bet-amount-usd": function ($event) {
                          return _vm.$set(_vm.authState, "betAmountUsd", $event)
                        },
                        "open-how-it-works": _vm.openHowGameWorksDialog,
                      },
                    },
                    [
                      _c("wheel-home-bet-content", {
                        attrs: { slot: "betContent" },
                        slot: "betContent",
                        model: {
                          value: _vm.currentColor,
                          callback: function ($$v) {
                            _vm.currentColor = $$v
                          },
                          expression: "currentColor",
                        },
                      }),
                      _c("wheel-home-bet-creator", {
                        attrs: {
                          slot: "createBetButton",
                          game: _vm.wheelState.game,
                          "user-bets": _vm.wheelState.userBets,
                          userBalanceUsd: _vm.allBalance,
                          "bet-color": _vm.currentColor,
                          "is-authenticated": _vm.authState.isAuthenticated(),
                          "bet-type": _vm.authState.betType(),
                          "bet-amount-usd": _vm.authState.betAmountUsd,
                          "selected-inv-items":
                            _vm.inventoryState.selectedIds(),
                          "selected-inventory-amount-usd":
                            _vm.inventoryState.selectedInventoryAmountUsd(),
                          "selected-ids": _vm.inventoryState.selectedIds(),
                        },
                        on: {
                          "update:betAmountUsd": function ($event) {
                            return _vm.$set(
                              _vm.authState,
                              "betAmountUsd",
                              $event
                            )
                          },
                          "update:bet-amount-usd": function ($event) {
                            return _vm.$set(
                              _vm.authState,
                              "betAmountUsd",
                              $event
                            )
                          },
                          "open-login": function ($event) {
                            return _vm.$emit("open-login-dialog")
                          },
                          "notify-error": _vm.handleNotifyError,
                          "submit-bet": _vm.handleBetSubmit,
                        },
                        slot: "createBetButton",
                      }),
                      _vm.wheelState.userBets &&
                      _vm.wheelState.userBets.length > 0
                        ? _c("wheel-sidebar-bets", {
                            attrs: {
                              slot: "userBets",
                              game: _vm.wheelState.game,
                              bets: _vm.wheelState.userBets,
                              "is-sticky-bet": false,
                            },
                            slot: "userBets",
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "wheel-game__bets" },
            [
              _vm.isSm
                ? _c("wheel-game-color-tabs", {
                    attrs: {
                      "x2-total-bank": _vm.wheelState.colorX2.totalBankUsd,
                      "x3-total-bank": _vm.wheelState.colorX3.totalBankUsd,
                      "x4-total-bank": _vm.wheelState.colorX4.totalBankUsd,
                      "x35-total-bank": _vm.wheelState.colorX35.totalBankUsd,
                      "current-color": _vm.currentColor,
                    },
                    on: {
                      "update:currentColor": function ($event) {
                        _vm.currentColor = $event
                      },
                      "update:current-color": function ($event) {
                        _vm.currentColor = $event
                      },
                    },
                  })
                : _vm._e(),
              !_vm.isSm || _vm.currentColor === _vm.Multiplier.X2
                ? _c("wheel-game-color", {
                    attrs: {
                      color: _vm.wheelState.colorX2,
                      multiplier: _vm.Multiplier.X2,
                      "win-multiplier": _vm.wheelState.game
                        ? _vm.wheelState.game.winColor
                        : null,
                    },
                    on: {
                      colorClicked: function ($event) {
                        return _vm.onColorClicked(_vm.Multiplier.X2)
                      },
                    },
                  })
                : _vm._e(),
              !_vm.isSm || _vm.currentColor === _vm.Multiplier.X3
                ? _c("wheel-game-color", {
                    attrs: {
                      color: _vm.wheelState.colorX3,
                      multiplier: _vm.Multiplier.X3,
                      "win-multiplier": _vm.wheelState.game
                        ? _vm.wheelState.game.winColor
                        : null,
                    },
                    on: {
                      colorClicked: function ($event) {
                        return _vm.onColorClicked(_vm.Multiplier.X3)
                      },
                    },
                  })
                : _vm._e(),
              !_vm.isSm || _vm.currentColor === _vm.Multiplier.X4
                ? _c("wheel-game-color", {
                    attrs: {
                      color: _vm.wheelState.colorX4,
                      multiplier: _vm.Multiplier.X4,
                      "win-multiplier": _vm.wheelState.game
                        ? _vm.wheelState.game.winColor
                        : null,
                    },
                    on: {
                      colorClicked: function ($event) {
                        return _vm.onColorClicked(_vm.Multiplier.X4)
                      },
                    },
                  })
                : _vm._e(),
              !_vm.isSm || _vm.currentColor === _vm.Multiplier.X35
                ? _c("wheel-game-color", {
                    attrs: {
                      color: _vm.wheelState.colorX35,
                      multiplier: _vm.Multiplier.X35,
                      "win-multiplier": _vm.wheelState.game
                        ? _vm.wheelState.game.winColor
                        : null,
                    },
                    on: {
                      colorClicked: function ($event) {
                        return _vm.onColorClicked(_vm.Multiplier.X35)
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm.isLg
            ? _c("div", { staticClass: "wheel-game__footer" }, [
                _c("div", {
                  staticClass: "wheel-game__shield icon icon_shield-bold",
                }),
                _c("div", { staticClass: "wheel-game__round" }, [
                  _c("div", { staticClass: "wheel-game__round-title" }, [
                    _vm._v("局号"),
                  ]),
                  _vm.wheelState.game && _vm.wheelState.game.id
                    ? _c("div", { staticClass: "wheel-game__round-number" }, [
                        _vm._v(" #" + _vm._s(_vm.wheelState.game.id) + " "),
                      ])
                    : _c("div", {
                        attrs: {
                          background: "rgba(102, 208, 138, 0.4)",
                          width: "5.5rem",
                          height: "1em",
                        },
                      }),
                ]),
                _vm.wheelState.game &&
                _vm.wheelState.game.fairGame &&
                _vm.wheelState.game.fairGame.serverSeedHash
                  ? _c("div", { staticClass: "wheel-game__hash" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.formatHash(
                              _vm.wheelState.game.fairGame.serverSeedHash
                            )
                          ) +
                          " "
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn_icon btn_copy",
                          on: {
                            click: function ($event) {
                              return _vm.copyRoundHash(
                                _vm.wheelState.game.fairGame.serverSeedHash
                              )
                            },
                          },
                        },
                        [_c("span", { staticClass: "icon icon_copy-bold-alt" })]
                      ),
                    ])
                  : _c("div", { staticClass: "wheel-game__hash-preload" }, [
                      _c("div", {
                        attrs: {
                          background: "rgba(102, 208, 138, 0.4)",
                          width: "11rem",
                          height: "1em",
                        },
                      }),
                      _vm._m(1),
                    ]),
              ])
            : _vm._e(),
        ]
      ),
    ]),
    _c("div", { staticClass: "wheel-home__description" }),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wheel-game__title" }, [
      _c("span", { staticClass: "icon icon_wheel" }),
      _c("span", [_vm._v("幸运轮盘")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      { staticClass: "btn btn_icon btn_copy", attrs: { disabled: "" } },
      [_c("span", { staticClass: "icon icon_copy-bold-alt" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }